import { render, staticRenderFns } from "./EditEmailCampaign.vue?vue&type=template&id=1b3c4fce&scoped=true&"
import script from "./EditEmailCampaign.vue?vue&type=script&lang=js&"
export * from "./EditEmailCampaign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c4fce",
  null
  
)

export default component.exports